interface Props {
  description: string;
}

export function WeaponBuildDescription({ description }: Props) {
  return (
    <div className="rounded-[8px] border border-[#262A2D] bg-[#141618] p-6">
      <div className="mb-3 font-mono text-[#F5A23E] text-xs tracking-[0.2em]">
        {"// FIELD NOTES"}
      </div>
      <p className="whitespace-pre-wrap text-[#B7BCC0] text-[15px] leading-relaxed">
        {description}
      </p>
    </div>
  );
}
